export default [
  {
    text: 'Schedule',
    value: 'schedule',
    visible: true,
    sortable: true,
    // Order matters here since we want to group actions by minutes away (delay_by_seconds),
    // days away at certain time (delay_by_days, dispatch_time), specific date (dispatch_datetime)
    sortByColumns: ['delay_by_seconds', 'delay_by_days', 'dispatch_time', 'dispatch_datetime'],
  },
  {
    text: '',
    value: 'dispatch_datetime',
    visible: false,
    sortable: true,
    hasLink: false,
  },
  {
    text: '',
    value: 'dispatch_time',
    visible: false,
    sortable: true,
    hasLink: false,
  },
  {
    text: '',
    value: 'delay_by_seconds',
    visible: false,
    sortable: true,
    hasLink: false,
  },
  {
    text: '',
    value: 'delay_by_days',
    visible: false,
    sortable: true,
    hasLink: false,
  },
  {
    text: '',
    value: 'recurrence',
    visible: false,
    sortable: true,
    hasLink: false,
  },
  {
    text: '',
    value: 'template_id',
    visible: false,
    sortable: true,
    hasLink: false,
  },
  {
    text: 'Stop on Text Reply',
    value: 'is_stopped_on_text_reply',
    visible: true,
    sortable: true,
    hasLink: false,
  },
];
